import { LOCAL, STAGE, PRODUCTION } from './environments';

export const BASE_URL_MAP = {
    'localhost:8080': LOCAL,
    'app-stage.vikart.ro': STAGE,
    'app.vikart.ro': PRODUCTION,
    // Hostname-ul stabil de pe Cloudflare Pages, ca sa se poata face smoke test
    // inainte de mutarea DNS-ului. Deploy-urile de preview au hash in hostname,
    // deci raman nemapate si cad pe LOCAL.
    'app-vikart-ro.pages.dev': PRODUCTION,
};

export const API_BASE_URL_MAP = {
    [PRODUCTION]: 'https://api.vikart.ro',
    [STAGE]: 'https://api-stage.vikart.ro',
    [LOCAL]: 'http://localhost:8888',
};

// Site-ul public, pentru intoarcerea din confirmarea telefonului (?return=vikart).
// Nu exista un vikart.ro de stage, asa ca stage-ul se intoarce pe productie.
export const VIKART_SITE_URL_MAP = {
    [PRODUCTION]: 'https://www.vikart.ro',
    [STAGE]: 'https://www.vikart.ro',
    [LOCAL]: 'http://localhost:3000',
};

export const API_BASE_WEB_SOKET_URL_MAP = {
    [PRODUCTION]: 'wss://api.vikart.ro',
    [STAGE]: 'wss://api-stage.vikart.ro',
    [LOCAL]: 'ws://localhost:8888',
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/constants/baseUrls.ts